
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/[stateElection]",
      function () {
        return require("private-next-pages/elections/[stateElection]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/[stateElection]"])
      });
    }
  